import { CwtApiEntity, CwtApiSchema, CwtCrudContract, CwtModel, CwtProp, CwtSchema } from "@cawita/core-front/api";
import { User } from "../auth";
import { Client, ClientAccess } from "../client";
import { Evaluation } from "../evaluation";

export enum ActivityLogType {
    client = 'client',
    clientAccess = 'clientAccess',
    evaluation = 'evaluation',
}

export enum ActivityLogEventType {
    create = 'create',
    update = 'update',
    delete = 'delete',
    access = 'access',
    export = 'export',
}

@CwtSchema()
export class ActivityLogDiff extends CwtApiSchema {
    @CwtProp({ ref: Client }) client?: Partial<Client>;
    @CwtProp({ ref: ClientAccess }) clientAccess?: Partial<ClientAccess>;
    @CwtProp({ ref: Evaluation }) evaluation?: Partial<Evaluation>;
}

export type ActivityLogDiffKey = keyof ActivityLogDiff;

@CwtModel({ name: 'activity-log' })
@CwtCrudContract({ path: 'activity-log' })
@CwtCrudContract({ path: 'for-manager/client/:clientId/activity-log', identifier: 'for-manager' })
export class ActivityLog extends CwtApiEntity {
    @CwtProp({ ref: Date }) date: Date;
    @CwtProp() logType: ActivityLogDiffKey;
    @CwtProp() eventType: ActivityLogEventType;
    @CwtProp({ ref: Client }) client: Client;
    @CwtProp({ ref: ClientAccess }) clientAccess: ClientAccess;
    @CwtProp({ ref: Evaluation }) evaluation: Evaluation;
    @CwtProp({ ref: User }) doer: User;
    @CwtProp({ ref: User }) user?: User;
    @CwtProp({ ref: ActivityLogDiff }) dataBefore: ActivityLogDiff;
    @CwtProp({ ref: ActivityLogDiff }) dataAfter: ActivityLogDiff;
}
